export default "__VITE_ASSET__d47fcb57__"